import React, { useEffect, useState } from 'react';
import { WithTranslation, withTranslation } from 'react-i18next';

import { IInsurerModel } from '../../helpers/models/insurerModel';
import { fetchInsurer } from '../../helpers/insurers';

const Insurers = (props: WithTranslation) => {
    const { t, i18n } = props;

    const [data, setData] = useState<IInsurerModel[]>([]);
    useEffect(() => {
        async function getData() {
            const insurersList = await fetchInsurer(i18n.language);
            setData(insurersList ?? []);
        }
        getData();
    }, [i18n.language]);

    return (
        <div className="insurers-container">
            <ul
                className="all-insurers__list"
                aria-label={t('all_insurers_list_aria_label', { ns: 'accessibility' })}
            >
                <li key={'all-insurers-priority-1'}>
                    <ul className="insurer__list insurers-priority-1">
                        {data
                            .filter((item) => item.priority === 1)
                            .map((item, i) => (
                                <li
                                    key={i}
                                    className="insurer__list-item insurers-priority-1__item"
                                >
                                    <img src={item.uriLogo} alt={item.name} />
                                </li>
                            ))}
                    </ul>
                </li>
                <li key={'all-insurers-priority-2'}>
                    <ul className="insurer__list insurers-priority-2">
                        {data
                            .filter((item) => item.priority === 2)
                            .map((item, i) => (
                                <li
                                    key={i}
                                    className="insurer__list-item insurers-priority-2__item"
                                >
                                    <img src={item.uriLogo} alt={item.name} />
                                </li>
                            ))}
                    </ul>
                </li>
                <li key={'all-insurers-priority-3'}>
                    <ul className="insurer__list insurers-priority-3">
                        {data
                            .filter((item) => item.priority === 3)
                            .map((item, i) => (
                                <li
                                    key={i}
                                    className="insurer__list-item insurers-priority-3__item"
                                >
                                    <img src={item.uriLogo} alt={item.name} />
                                </li>
                            ))}
                    </ul>
                </li>
            </ul>
        </div>
    );
};

export default withTranslation()(Insurers);
